import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdvertisingWorkflowImage from '../../components/AdvertisingWorkflowImage/AdvertisingWorkflowImage';
import Button from '../../components/Button/Button';
import { P } from '../../components/Text/Text';
import { RoutesE } from '../../routes/routesData';

import styles from './process.module.scss';

const PROCESS_STEPS = [
    {
        title: 'Advertising Agency',
        description: 'Begin the process by creating ad delivery projects and selecting relevant post companies and broadcasters.',
    },
    {
        title: 'Post Company',
        description: 'Upload the required media files, which go through quality check and can then be viewed online and confirmed by the ad agency.',
    },
    {
        title: 'Broadcaster',
        description: 'Receive the files, view them online, set a house number, and automatically transfer the files to their servers with a click of a button.',
    },
];

const Process = () => {
    const navigate = useNavigate();

    const navigateToLogin = () => {
        navigate(RoutesE.CONTACT_US);
    };

    return (
        <main className={styles.mainWrapper}>
            <h1>The Advertising Workflow</h1>
            <AdvertisingWorkflowImage />
            <ul className={styles.processStepList}>
                {PROCESS_STEPS.map((step, index) => (
                    <li key={step.title}>
                        <h2>{step.title}</h2>
                        <p className={styles.description}>{step.description}</p>
                    </li>
                ))}
            </ul>
            <div className={styles.footer}>
                <P>Manage and deliver video ads to broadcasters</P>
                <P>in one whole eco-system.</P>
                <Button onClick={navigateToLogin}>Get started</Button>
            </div>
        </main>
    );
};

export default Process;